import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import depot from './modules/depot'
Vue.use(Vuex)

export default new Vuex.Store({
  state:{},
  mutations:{},
  actions:{},
  modules:{
    user,
    depot,
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js